"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _field = _interopRequireDefault(require("./field"));

var _utils = _interopRequireDefault(require("../utils"));

var _vanillaTextMask = require("vanilla-text-mask");

var _map = _interopRequireDefault(require("lodash/map"));

var TextField =
/*#__PURE__*/
function (_Field) {
  (0, _inherits2.default)(TextField, _Field);

  function TextField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TextField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'TextField');
    return _this;
  }

  (0, _createClass2.default)(TextField, [{
    key: "_setTextFieldSchema",
    value: function _setTextFieldSchema() {
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'minLength',
            component: 'IntegerField',
            label: 'Min Length',
            docLevel: 'basic'
          }, {
            name: 'maxLength',
            component: 'IntegerField',
            label: 'Max Length',
            docLevel: 'basic'
          }, {
            name: 'minWords',
            component: 'IntegerField',
            label: 'Min Words' // docLevel: 'basic' // Document once implemented

          }, {
            name: 'maxWords',
            component: 'IntegerField',
            label: 'Max Words' // docLevel: 'basic' // Document once implemented

          }, {
            // TODO: define list of acceptable values
            name: 'type',
            component: 'TextField'
          }, {
            name: 'invalidRegExp',
            component: 'TextField',
            label: 'Invalid RegExp',
            docLevel: 'basic',
            help: 'Invalid if this regular expression matches, e.g. /foo/'
          }, {
            name: 'multiline',
            component: 'BooleanField',
            label: 'Multiline',
            docLevel: 'basic'
          }, {
            name: 'rows',
            component: 'IntegerField'
          }, {
            name: 'rowsMax',
            component: 'IntegerField'
          }, {
            name: 'mask',
            component: 'Field'
          }, {
            name: 'unmask',
            component: 'RegExpField'
          }],
          hidden: this._hideTextFieldSchema
        }
      });
    }
  }, {
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(TextField.prototype), "_create", this).call(this, props);
      this._requireString = true;

      this._setTextFieldSchema();
    }
  }, {
    key: "_toValidatorProps",
    value: function _toValidatorProps() {
      var _this2 = this;

      return {
        get: function get(name) {
          switch (name) {
            case 'length':
              return _this2.get('value').length;

            case 'words':
              return _this2.get('value').split(/\s+/).length;

            default:
              return _this2.get(name);
          }
        }
      };
    }
  }, {
    key: "validate",
    value: function validate() {
      (0, _get2.default)((0, _getPrototypeOf3.default)(TextField.prototype), "validate", this).call(this);

      if (!this.isBlank()) {
        var value = this.getValue();

        if (typeof value === 'string') {
          var minLength = this.get('minLength');
          var maxLength = this.get('maxLength');
          var invalidRegExp = this.get('invalidRegExp');

          if (minLength !== null && value.length < minLength) {
            this.setErr("".concat(minLength, " characters or more"));
          } else if (maxLength !== null && value.length > maxLength) {
            this.setErr("".concat(maxLength, " characters or less"));
          } else if (invalidRegExp && _utils.default.isRegExpString(invalidRegExp) && _utils.default.toRegExp(invalidRegExp).test(value)) {
            this.setErr("invalid");
          }
        } else if (this._requireString) {
          this.setErr("must be a string");
        }
      } // TODO: minWords, maxWords

    }
  }, {
    key: "_stringToArrayMask",
    value: function _stringToArrayMask(mask) {
      return (0, _map.default)(mask, function (item) {
        return item === '.' ? /./ : item;
      });
    }
  }, {
    key: "_formatMask",
    value: function _formatMask(mask) {
      if (Array.isArray(mask)) {
        return mask.map(function (item) {
          // Is the item a RegExp or a string that is not formatted as a RegExp?
          if (item instanceof RegExp || !_utils.default.isRegExpString(item)) {
            return item;
          } else {
            // The string is formatted as a RegExp, e.g. '/foo/i'
            return _utils.default.toRegExp(item);
          }
        });
      } else if (typeof mask === 'string') {
        return this._stringToArrayMask(mask);
      } else {
        // Function
        return mask;
      }
    }
  }, {
    key: "_formatUnmask",
    value: function _formatUnmask(unmask) {
      return _utils.default.toRegExp(unmask);
    }
  }, {
    key: "set",
    value: function set(props) {
      var clonedProps = Object.assign({}, props); // Convert to RegExps?

      if (clonedProps.mask !== undefined) {
        clonedProps.mask = this._formatMask(clonedProps.mask);
      } // Convert to RegExp?


      if (clonedProps.unmask !== undefined) {
        clonedProps.unmask = this._formatUnmask(clonedProps.unmask);
      }

      (0, _get2.default)((0, _getPrototypeOf3.default)(TextField.prototype), "set", this).call(this, clonedProps);
    }
  }, {
    key: "_conformToMask",
    value: function _conformToMask(value, mask) {
      var conformed = (0, _vanillaTextMask.conformToMask)(value, mask, {
        guide: false
      });
      return conformed.conformedValue;
    }
  }, {
    key: "toConformedValue",
    value: function toConformedValue(value) {
      return this._conformToMask(value, this.get('mask'));
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      if (this.isBlank() || !this.get('mask')) {
        return (0, _get2.default)((0, _getPrototypeOf3.default)(TextField.prototype), "getDisplayValue", this).call(this);
      } else {
        return this.toConformedValue(this.getUIValue());
      }
    }
  }, {
    key: "toUnmaskedValue",
    value: function toUnmaskedValue(value) {
      // The unmask is used to remove any formatting that should not be in our store
      var unmask = this.get('unmask');

      if (this.isValueBlank(value) || !unmask) {
        return value;
      } else {
        return value.replace(unmask, '');
      }
    }
  }, {
    key: "fromUIValue",
    value: function fromUIValue(value) {
      return this.toUnmaskedValue(value);
    }
  }, {
    key: "getUIValue",
    value: function getUIValue() {
      // Convert to string so that we can perform string functions on the value
      return this.isBlank() ? '' : String(this.get('value'));
    }
  }, {
    key: "isValueBlank",
    value: function isValueBlank(value) {
      // Value can be '' when user clears value in UI
      return (0, _get2.default)((0, _getPrototypeOf3.default)(TextField.prototype), "isValueBlank", this).call(this, value) || value === '';
    }
  }]);
  return TextField;
}(_field.default);

exports.default = TextField;